import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MaterialInfoListService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/material';

  getUrl(): string {
    return this.url;
  }

  /**
   * 同步物料
   * @param startDate 开始日期
   * @param endDate 结束日期
   * @param syncMatCode 物料编号
   */
  syncMaterial(startDate, endDate, syncMatCode): Observable<any> {
    const url = `${this.getUrl()}/sync?startDate=` + startDate +
      '&endDate=' + endDate + '&materialCode=' + syncMatCode;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getWithItemList`)),
      catchError(this.handleError<any>(`getWithItemList`)),
    );
  }

  /**
   * 获取与当前供应商相关的物料idList
   * @param startDate 开始日期
   * @param endDate 结束日期
   * @param syncMatCode 物料编号
   */
  getLinkedMatIdList(): Observable<any> {
    const url = `${this.getUrl()}/linkedMatIdList`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getLinkedMatIdList`)),
      catchError(this.handleError<any>(`getLinkedMatIdList`)),
    );
  }

  getByMatTypeCode(params: HttpParams): Observable<any> {
    const url = `${this.getUrl()}/find-by-mat-type-code`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }

  getAllCategory(params: HttpParams): Observable<any> {
    const url = `${this.getUrl()}/all-category`;
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params,
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }

  syncMat(zsrmMmMaterialGetInput: any): Observable<any> {
    const url = `${this.getUrl()}/syncMaterial`;
    return this.http.post<any>(url, zsrmMmMaterialGetInput, httpOptions).pipe(
      tap(_ => this.log('syncMaterial')),
      catchError(this.handleError<any>('syncMaterial')),
    );
  }

  shelfMall(ids: any[]): Observable<any> {
    const url = `${this.getUrl()}/shelf-mall`;
    return this.http.post<any>(url, ids).pipe(
      tap(_ => this.log(`/shelf-mall`)),
      catchError(this.handleError<any>(`/shelf-mall`)),
    );
  }

  obtainedMall(ids: any[]): Observable<any> {
    const url = `${this.getUrl()}/obtained-mall`;
    return this.http.post<any>(url, ids).pipe(
      tap(_ => this.log(`/obtained-mall`)),
      catchError(this.handleError<any>(`/obtained-mall`)),
    );
  }

  batchDelete(ids: any[]): Observable<any> {
    const url = `${this.getUrl()}/batch/delete`;
    return this.http.post<any>(url, ids).pipe(
      tap(_ => this.log(`/batch/delete`)),
      catchError(this.handleError<any>(`/batch/delete`)),
    );
  }

}
